/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zoom_ValueInputs */



/**
* | output |
* | --- |
* | "Zoom Value" |
*
* @param {Zoom_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const zoom_value = /** @type {((inputs?: Zoom_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zoom_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Valeur du zoom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zoomwert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Valore di zoom")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Значение масштабирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Valor de zoom")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("缩放值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ズーム値")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ज़ूम वैल्यू")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Valor do zoom")
	return /** @type {LocalizedString} */ ("Zoom Value")
});